import { render } from "./DecisionGrid.vue?vue&type=template&id=222f4569&scoped=true"
import script from "./DecisionGrid.vue?vue&type=script&lang=js"
export * from "./DecisionGrid.vue?vue&type=script&lang=js"

import "./DecisionGrid.vue?vue&type=style&index=0&id=222f4569&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222f4569"]])

export default __exports__